import { useEffect } from 'react';

const useKeydown = callback => {
  useEffect(() => {
    const handleKeydown = () => {
      callback();
    };

    document.addEventListener('keydown', handleKeydown);
    return () => {
      document.removeEventListener('keydown', handleKeydown);
    };
  }, []);
};

export default useKeydown;
